import AllWarehousesAppConfig from './all-warehouses/DatasAppConfig';
import ProductsAppConfig from './products/DatasAppConfig';
import OrderRequestsAppConfig from './order-requests/DatasAppConfig';
import ReturnedProducts from './returned-products/DatasAppConfig';
import WarehouseTransferAppConfig from './warehouse-transfers/DatasAppConfig';
import WarehouseHistoryConfig from './history/DatasAppConfig';
import WarehouseAssistant from './assistant/DatasAppConfig';

const WarehousesAppConfig = [
	AllWarehousesAppConfig,
	ProductsAppConfig,
	OrderRequestsAppConfig,
	ReturnedProducts,
	WarehouseTransferAppConfig,
	WarehouseHistoryConfig,
	WarehouseAssistant
];

export default WarehousesAppConfig;
